// The work-shape vocabulary the admin surfaces tag and filter by — the
// engagement SHAPE of a project ("project" = one scoped deliverable, "ongoing"
// = a continuing relationship, "hybrid" = a project that continues), latched by
// ATTENTION per turn and settled by PULSE at brief approval
// (backend/recruiter/models.py, WorkspaceState.work_shape).
//
// Mirrors `WORK_SHAPES` in backend/recruiter/repo/_helpers.py, which normalizes
// the value at every repo edge, so the strings here are the only ones a payload
// can carry. "none" is the filters' extra option: a project the agents have not
// classified yet (the metadata key is absent until something latches it).

export const WORK_SHAPES = ["project", "ongoing", "hybrid"] as const;

export type WorkShape = (typeof WORK_SHAPES)[number];

/** The human label per shape (plus the filters' "none" bucket). "One-off"
 *  rather than "Project" for the settled default, because this chip renders
 *  beside the Kind column, which already prints "project" for something else
 *  entirely. */
export function workShapeLabel(value: string): string {
  switch (value) {
    case "project":
      return "One-off";
    case "ongoing":
      return "Ongoing";
    case "hybrid":
      return "Hybrid";
    case "none":
      return "Not classified";
    default:
      return value;
  }
}

export function isWorkShape(value: unknown): value is WorkShape {
  return typeof value === "string" && (WORK_SHAPES as readonly string[]).includes(value);
}
